import { TeamOutlined, RocketOutlined, BulbOutlined } from '@ant-design/icons';

const admin = {
  id: 'group-admin',
  title: 'Administração',
  type: 'group',
  children: [
    {
      id: 'admin-usuarios',
      title: 'Usuários',
      type: 'item',
      url: '/admin/usuarios',
      icon: TeamOutlined,
      breadcrumbs: false
    },
    {
      id: 'admin-roadmap',
      title: 'Gerenciar Roadmap',
      type: 'item',
      url: '/admin/roadmap',
      icon: RocketOutlined,
      breadcrumbs: false
    },
    {
      id: 'admin-sugestoes',
      title: 'Sugestões',
      type: 'item',
      url: '/admin/sugestoes',
      icon: BulbOutlined,
      breadcrumbs: false
    }
  ]
};

export default admin;
